import { type LinkProps as MuiLinkProps, type Theme } from '@mui/material';
import { type SystemStyleObject } from '@mui/system';
import { Link as LinkExtra } from '@next-box/link-extra';
import { type AnchorHTMLAttributes, type ReactNode } from 'react';

export type LinkProps = {
  children: ReactNode;
  sx?: SystemStyleObject<Theme>;
  to?: string;
} & AnchorHTMLAttributes<HTMLAnchorElement> &
  MuiLinkProps;

export const Link = ({ children, sx, to, ...otherProps }: LinkProps) => {
  return (
    <LinkExtra<MuiLinkProps> color="inherit" disableRouterCache={false} href={to} sx={sx} {...otherProps}>
      {children}
    </LinkExtra>
  );
};
